import { render, staticRenderFns } from "./toufatu.vue?vue&type=template&id=3b59e61a&"
import script from "./toufatu.vue?vue&type=script&lang=ts&"
export * from "./toufatu.vue?vue&type=script&lang=ts&"
import style0 from "./toufatu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports